module.exports = __webpack_public_path__ + "h5/img/PDF5.67cae181.jpg";